/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

export default createUseStyles(
  ({
    breakpoints: {
      values: { xs }
    },
    spacing: { unit },
    typography: { fontWeightHeavy }
  }) => ({
    hidden: {
      display: 'none !important'
    },
    wrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      margin: [0, 25 * unit],
      [`@media only screen and (max-width: ${1600}px) and (min-width: ${xs}px)`]: {
        margin: 0
      }
    },
    header: {
      display: 'flex',
      justifyContent: 'center',
      fontWeight: fontWeightHeavy,
      fontSize: 3.125 * unit
    },
    navigation: {
      display: 'flex',
      justifyContent: 'center',
      marginLeft: 5 * unit
    },
    contentWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }
  })
);
